import { get } from "lodash";

const isProduction =
  (process.env.REACT_APP_NODE_ENV || "").toLowerCase() === "production";

const featureFlags = {
  // Reward-points/redemption management (Point History, Mission, Reward Catalog, Redemption
  // Settings/Report, etc.). Rolled out to production after sandbox validation, so enabled everywhere.
  rewardPointsCheckout: true,
  updateOrderStatus: true,

  newClaimPayoutFlow: true,

  // Admin sub-account management (link/move/convert-to-main on the user detail page). Off in
  // production until the rollout is signed off; enabled everywhere else.
  subAccountManagement: !isProduction,
};

export function getFeatureFlag(key) {
  return get(featureFlags, key, false);
}
